import React, { useState } from "react";
import Swal from 'sweetalert2';

const CommentForm = ({ onSubmit }) => {
  const [commentValue, setCommentValue] = useState('');

  const handleValueChange = (e) => {
    setCommentValue(e.target.value);
  };

  const handleSubmitComments = (e) => {
    e.preventDefault();
    if(commentValue === '') {
        Swal.fire({
            icon: 'warning',
            title: '알림',
            text: '댓글을 먼저 입력해주세요.'
        });
        return;
    }
    onSubmit(commentValue);
    setCommentValue('');
  };

  return (
    <li className="comments-form">
        <form onSubmit={handleSubmitComments}>
            <span className="ps_box">
                <input 
                    type="text" 
                    className="int" 
                    placeholder='write comment'
                    value={commentValue}
                    onChange={handleValueChange}
                />
            </span>
            <button className="comments-submit-button">
                등록
            </button>
        </form>
    </li>
  );
};

export default CommentForm;
